var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{ref:_vm.fieldReference,attrs:{"prefix":"€","label":_vm.label,"outlined":"","dense":""},model:{value:(_vm.theamount),callback:function ($$v) {_vm.theamount=$$v},expression:"theamount"}})}
var staticRenderFns = []

export { render, staticRenderFns }